import { useEffect } from "react";
import SortableTree, {
  getTreeFromFlatData,
  getFlatDataFromTree,
  changeNodeAtPath,
  removeNodeAtPath,
  toggleExpandedForAll,
  walk,
} from "react-sortable-tree";
import CustomNodeContentRenderer from "./CustomNodeContentRenderer";
import { useSelector } from "react-redux";
import store from "../../stores/store";
import {
  buildSLDFile,
  getLayerById,
  removeLayerCQL,
  removeLayerSLD,
  removeMapAllLayers,
  setLayerOpacity,
  setLayerProperty,
  setLayerVisibility,
  setSLD,
  zoomToExtent,
} from "../map/mapUtils";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Checkbox from "react-three-state-checkbox";
import { cloneDeep } from "lodash";
import LayerManager from "../layerManager/layerManager";
import { key, showDataTable, trans } from "../../lib/utils";
import { useState } from "react";
import TimeDimensionDropdown from "../controls/timeDimensionDropdown";
import DownloadFeatures from "../controls/downloadFeatures";
import LayerConfiguration from "../layerConfiguration/layerConfiguration";
import LoadConfiguration from "../controls/loadConfiguration";
import LayerPreviewComponent from "../layerManager/layerPreviewComponent";

function LayerTree() {
  const layerTree = useSelector((state) => store.getState().layerTree);
  const sources = useSelector((state) => store.getState().sources);
  const layers = useSelector((state) => store.getState().layers);
  const swipeLayers = useSelector((state) => store.getState().swipe.layers);
  const timeDimensionLayers = useSelector(
    (state) => store.getState().timeDimension.layers
  );
  const cqlFilters = useSelector((state) => store.getState().cqlFilter);
  const sldEditors = useSelector(
    (state) => store.getState().sldEditor.sldEditors
  );

  const [searchQuery, setSearchQuery] = useState(null);
  const [groupTitle, setGroupTitle] = useState(null);

  const [treeLoaded, setTreeLoaded] = useState(null);

  useEffect(() => {}, [sources]);

  const customSearchMethod = ({ node, searchQuery }) => {
    if (layers[node.id] && searchQuery && window["map"]) {
      return (
        layers[node.id]?.title
          ?.toLowerCase()
          .indexOf(searchQuery.toLowerCase()) > -1 ||
        layers[node.id]?.name
          ?.toLowerCase()
          .indexOf(searchQuery.toLowerCase()) > -1
      );
    }
    return true;
  };

  function isChecked(node) {
    let checkedStore = [];

    function reccursive(data) {
      data?.children?.forEach((el) => {
        checkedStore.push(el.checked);
        reccursive(el);
      });
    }

    reccursive(node);

    checkedStore = [...new Set(checkedStore)];

    if (checkedStore.length === 1) {
      if (checkedStore[0] === false) {
        return false;
      } else {
        return true;
      }
    } else {
      return node.checked;
    }
  }

  function isIntermidiate(node) {
    let checkedStore = [];

    function reccursive(data) {
      data?.children?.forEach((el) => {
        checkedStore.push(el.checked);
        reccursive(el);
      });
    }

    reccursive(node);

    checkedStore = [...new Set(checkedStore)];

    if (checkedStore.length <= 1) {
      return false;
    } else {
      return true;
    }
  }

  const collapseAll = () => {
    const newTree = toggleExpandedForAll({
      treeData: layerTree,
      expanded: false,
    });

    store.dispatch({
      type: "layerTree/state/update",
      payload: newTree,
    });
  };

  const expandAll = () => {
    const newTree = toggleExpandedForAll({
      treeData: layerTree,
      expanded: true,
    });

    store.dispatch({
      type: "layerTree/state/update",
      payload: newTree,
    });
  };

  return (
    <div className="w-100">
      <div className="p-2">
        <div className="d-flex">
          <button
            className="btn btn-secondary btn-sm  form-control me-2"
            type="button"
            onClick={() => {
              window["primaryModal"].setState({
                title: trans("Manage layers"),
                size: "xl",
                show: true,
                body: <LayerManager></LayerManager>,
              });
            }}
          >
            <span className="text-white">
              <i className="fas fa-plus me-2"></i>
              {trans("Add Data / Manage layers")}
            </span>
          </button>
          <button
            className="btn btn-success btn-sm form-control  "
            type="button"
            onClick={() => {
              window["primaryModal"].setState({
                show: true,
                size: "default",
                title: trans("Load configuration"),
                body: <LoadConfiguration></LoadConfiguration>,
                footer: [
                  <button
                    className="btn btn-sm btn-link border"
                    onClick={() => {
                      window["primaryModal"].setState({ show: false });
                    }}
                  >
                    {trans("Cancel")}
                  </button>,
                ],
              });
            }}
          >
            <span className="text-white">
              <i className="fas fa-file-upload me-2"></i>
              {trans("Load configuration")}
            </span>
          </button>
        </div>
        <input
          type="text"
          className="form-control form-control-sm mt-2"
          placeholder={trans("Search layers...")}
          onChange={(e) => {
            setSearchQuery(e.target.value);
          }}
        ></input>
      </div>

      <div className="text-end">
        <span
          role="button"
          className="text-link small p-2"
          onClick={() => {
            collapseAll();
          }}
        >
          {trans("Collapse All")}
        </span>
        <span
          role="button"
          className="text-link small p-2"
          onClick={() => {
            expandAll();
          }}
        >
          {trans("Expand All")}
        </span>
        <span
          role="button"
          className="text-link small p-2"
          onClick={() => {
            window["primaryModal"].setState({
              show: true,
              size: "default",
              title: trans("Remove all groups and layers"),
              body: (
                <div className="p-2">
                  {trans(
                    "Are you sure you want to remove all groups and layers?"
                  )}
                </div>
              ),
              footer: [
                <button
                  className="btn btn-sm btn-link border"
                  onClick={() => {
                    window["primaryModal"].setState({ show: false });
                  }}
                >
                  {trans("Cancel")}
                </button>,
                <button
                  className="btn btn-sm btn-danger text-white"
                  onClick={() => {
                    store.dispatch({
                      type: "layer/removeall",
                    });

                    window["primaryModal"].setState({ show: false });
                  }}
                >
                  {trans("Remove all")}
                </button>,
              ],
            });
          }}
        >
          {trans("Remove All")}
        </span>
        <span
          role="button"
          className="text-link small p-2"
          onClick={() => {
            window["primaryModal"].setState({
              show: true,
              size: "default",
              title: trans("New group"),
              body: (
                <div className="p-2">
                  <input
                    type="text"
                    id="group-title-id"
                    className="form-control"
                    placeholder={trans("Type group title")}
                  ></input>
                </div>
              ),
              footer: [
                <button
                  className="btn btn-sm btn-link border"
                  onClick={() => {
                    window["primaryModal"].setState({ show: false });
                  }}
                >
                  {trans("Cancel")}
                </button>,
                <button
                  className="btn btn-sm btn-secondary text-white"
                  onClick={() => {
                    store.dispatch({
                      type: "layerTree/group/add",
                      payload: {
                        id: key(),
                        title: document.getElementById("group-title-id").value,
                      },
                    });

                    window["primaryModal"].setState({ show: false });
                  }}
                >
                  {trans("Create group")}
                </button>,
              ],
            });
          }}
        >
          <i className="fas fa-plus me-1 small"></i>
          {trans("Add group")}
        </span>
      </div>
      <PerfectScrollbar className="scrollbar-recaclulate p-2">
        <SortableTree
          treeData={layerTree}
          isVirtualized={false}
          onMoveNode={(args) => {}}
          onChange={(_treeData) => {
            if (treeLoaded) {
              console.log(_treeData);
              store.dispatch({
                type: "layerTree/state/update",
                payload: _treeData,
              });
            } else {
              setTreeLoaded(true);
            }
          }}
          searchQuery={searchQuery}
          searchMethod={customSearchMethod}
          nodeContentRenderer={CustomNodeContentRenderer}
          generateNodeProps={({ node, path, treeIndex }) => ({
            more: () => {
              if (node.type === "layer") {
                if (!layers[node.layer.id]) {
                  return null;
                }

                return (
                  <div
                    id={"collapse-".concat(node.key)}
                    className=" mb-3 bg-white border-top border-bottom p-2"
                  >
                    <div>
                      <div className=" mt-1 ">
                        <small className="text-secondary">
                          {trans("Name")}: {layers[node.id]?.name}
                        </small>
                      </div>
                      <div className="mb-2 d-flex mt-2">
                        <label className="form-label small mb-0 me-2">
                          {trans("Opacity")} {layers[node.id]?.opacity}
                        </label>
                        <input
                          type="range"
                          min="1"
                          max="10"
                          value={layers[node.id]?.opacity * 10}
                          className=" w-100 d-block me-2"
                          onChange={(e) => {
                            setLayerOpacity(
                              layers[node.id],
                              e.target.value / 10
                            );
                            store.dispatch({
                              type: "layer/update",
                              payload: {
                                id: node.layer.id,
                                property: "opacity",
                                value: e.target.value / 10,
                              },
                            });
                          }}
                        ></input>
                      </div>

                      <div className="mb-3 " style={{ whiteSpace: "normal" }}>
                        <button
                          type="button"
                          className="btn btn-sm btn-link border small m-1"
                          onClick={(e) => {
                            zoomToExtent(layers[node.id]);
                          }}
                        >
                          <i className="fas fa-compress me-2"></i>
                          {trans("Zoom to extent")}
                        </button>

                        {layers[node.id].searchable ? (
                          <button
                            type="button"
                            className="btn btn-sm btn-link border small m-1"
                            onClick={(e) => {
                              if (node.layer) {
                                showDataTable(
                                  layers[node.layer.id],
                                  sources[node.layer.source.id]
                                );
                              }
                            }}
                          >
                            <i className="far fa-list-alt me-2"></i>
                            {trans("Data table")}
                          </button>
                        ) : (
                          ""
                        )}

                        <button
                          type="button"
                          className="btn btn-sm btn-link border small m-1"
                          onClick={(e) => {
                            window["primaryModal"].setState({
                              show: true,
                              size: "lg",
                              title: trans("Layer information"),
                              body: (
                                <LayerPreviewComponent
                                  key={key()}
                                  layer={layers[node.layer.id]}
                                ></LayerPreviewComponent>
                              ),
                            });
                          }}
                        >
                          <i className="fas fa-info-circle me-2"></i>
                          {trans("Layer Info")}
                        </button>

                        {layers[node.id].searchable ? (
                          <button
                            type="button"
                            className="btn btn-sm btn-link border small m-1"
                            data-bs-toggle="collapse"
                            data-bs-target={"#sidebar"}
                            onClick={(e) => {
                              store.dispatch({
                                type: "search/update",
                                payload: { id: node.id, groups: [] },
                              });

                              store.dispatch({
                                type: "app/leftPanelActiveTab",
                                payload: "search",
                              });
                            }}
                          >
                            <i className="far fa-list-alt me-2"></i>
                            {trans("Search features")}
                          </button>
                        ) : (
                          ""
                        )}

                        <div className="dropdown d-inline-block">
                          <button
                            className="btn btn-sm btn-link border small m-1 d-inline-block dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {trans("More")}
                          </button>
                          <ul
                            className="dropdown-menu small"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <span
                                className="dropdown-item small"
                                role="button"
                                onClick={() => {
                                  store.dispatch({
                                    type: "swipe/layer/toggle",
                                    payload: layers[node.id],
                                  });
                                }}
                              >
                                {swipeLayers[node.id]
                                  ? trans("Remove from swipe")
                                  : trans("Add to swipe")}
                              </span>
                            </li>
                            {swipeLayers[node.id]?.source?.type !==
                            "GEOJSON" ? (
                              <li>
                                <span
                                  className="dropdown-item small"
                                  role="button"
                                  onClick={() => {
                                    window["primaryModal"].setState({
                                      title: trans("Download features"),
                                      show: true,
                                      body: (
                                        <DownloadFeatures
                                          layer={layers[node.id]}
                                        ></DownloadFeatures>
                                      ),
                                    });
                                  }}
                                >
                                  {trans("Download")}
                                </span>
                              </li>
                            ) : (
                              ""
                            )}
                            <li>
                              <span
                                className="dropdown-item small"
                                role="button"
                                onClick={() => {
                                  getLayerById(node.id).getSource().refresh();
                                }}
                              >
                                {trans("Refresh")}
                              </span>
                            </li>
                            <li>
                              <span
                                className="dropdown-item small"
                                role="button"
                                onClick={() => {
                                  window["primaryModal"].setState({
                                    show: true,
                                    size: "xl",
                                    title: trans("Layer configuration"),
                                    body: (
                                      <LayerConfiguration
                                        layer={layers[node.id]}
                                      ></LayerConfiguration>
                                    ),
                                    footer: [
                                      <button
                                        className="btn btn-sm btn-link border"
                                        onClick={() => {
                                          window["primaryModal"].setState({
                                            show: false,
                                          });
                                        }}
                                      >
                                        {trans("Cancel")}
                                      </button>,
                                    ],
                                  });
                                }}
                              >
                                {trans("Configure layer")}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="mb-2">
                      {swipeLayers[node.id] ? (
                        <span className="badge bg-warning text-dark m-1">
                          <small>{trans("Swipe selected")}</small>
                        </span>
                      ) : (
                        ""
                      )}
                      {layers[node.id].cqlFilter ? (
                        <span className="badge bg-warning text-dark m-1">
                          <small>{trans("CQL Filter enabled")}</small>
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      {timeDimensionLayers[node.id]?.dimensions ? (
                        <TimeDimensionDropdown
                          layer={timeDimensionLayers[node.id]}
                          value={timeDimensionLayers[node.id].defaultDimension}
                          dimensions={timeDimensionLayers[node.id]?.dimensions}
                        ></TimeDimensionDropdown>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="mb-3">
                      <ul className="nav nav-tabs navbar-expand small">
                        <li className={"nav-item "}>
                          <span
                            className="nav-link color-strong-grey nav-ellipsis active"
                            role="button"
                            data-bs-toggle="tab"
                            data-bs-target={"#tab1-".concat(node.id)}
                          >
                            <span className="color-black">
                              {trans("Legend")}
                            </span>
                          </span>
                        </li>
                        <li className={"nav-item "}>
                          <span
                            className="nav-link color-strong-grey nav-ellipsis "
                            data-bs-toggle="tab"
                            role="button"
                            data-bs-target={"#tab2-".concat(node.id)}
                          >
                            <span className="color-black">
                              {trans("Description")}
                            </span>
                          </span>
                        </li>
                        {layers[node.id]?.searchable ? (
                          <li className={"nav-item "}>
                            <span
                              className="nav-link color-strong-grey nav-ellipsis "
                              data-bs-toggle="tab"
                              role="button"
                              data-bs-target={"#tab3-".concat(node.id)}
                            >
                              <span className="color-black">
                                {trans("CQL Filter")}
                              </span>
                            </span>
                          </li>
                        ) : (
                          ""
                        )}

                        <li className={"nav-item "}>
                          <span
                            className="nav-link color-strong-grey nav-ellipsis "
                            data-bs-toggle="tab"
                            role="button"
                            data-bs-target={"#tab4-".concat(node.id)}
                          >
                            <span className="color-black">
                              <i className="fas fa-cog me-2"></i>
                              {trans("Settings")}
                            </span>
                          </span>
                        </li>
                      </ul>
                      <div className="tab-content mt-3 ">
                        <div
                          className={"tab-pane fade active show"}
                          id={"tab1-".concat(node.id)}
                          role="tabpanel"
                          aria-labelledby="legend-tab"
                        >
                          {layers[node.id]?.slds ? (
                            <div className="mb-3">
                              <label className="form-label small mb-1 me-2">
                                {trans("Available SLDs")}
                              </label>
                              <select
                                className="form-select form-select-sm"
                                onChange={(e) => {
                                  store.dispatch({
                                    type: "layer/update",
                                    payload: {
                                      property: "activeSLD",
                                      value: e.target.value,
                                      id: node.id,
                                    },
                                  });

                                  if (!e.target.value) {
                                    removeLayerSLD(layers[node.id]);
                                    store.dispatch({
                                      type: "layer/update",
                                      payload: {
                                        property: "legendSLD",
                                        value: null,
                                        id: node.id,
                                      },
                                    });
                                  } else {
                                    setSLD(
                                      layers[node.id],
                                      e.target.value,
                                      sldEditors[node.id]
                                    );

                                    if (layers[node.id].source.type === "WMS") {
                                      if (sldEditors) {
                                        if (sldEditors[node.id]) {
                                          store.dispatch({
                                            type: "layer/update",
                                            payload: {
                                              property: "legendSLD",
                                              value: layers[
                                                node.id
                                              ]?.legend.concat(
                                                "&SLD_BODY=",
                                                encodeURIComponent(
                                                  buildSLDFile(
                                                    sldEditors[node.id][
                                                      e.target.value
                                                    ].groups,
                                                    layers[node.id]
                                                  )
                                                )
                                              ),
                                              id: node.id,
                                            },
                                          });
                                        } else {
                                          store.dispatch({
                                            type: "layer/update",
                                            payload: {
                                              property: "legendSLD",
                                              value: layers[
                                                node.id
                                              ]?.legend.concat(
                                                "&STYLE=",
                                                e.target.value
                                              ),
                                              id: node.id,
                                            },
                                          });
                                        }
                                      }
                                    }
                                  }
                                }}
                                value={layers[node.id].activeSLD}
                              >
                                <option value="">{trans("Default")}</option>
                                {layers[node.id].slds.map((el) => {
                                  return (
                                    <option value={el.sldId}>{el.title}</option>
                                  );
                                })}
                              </select>
                            </div>
                          ) : (
                            ""
                          )}
                          <img
                            src={
                              layers[node.id]?.legendSLD
                                ? layers[node.id]?.legendSLD
                                : layers[node.id]?.legend
                            }
                            className="ms-1 me-2"
                            style={{ maxWidth: "23rem" }}
                          ></img>
                        </div>
                        <div
                          className={"tab-pane fade p-2"}
                          id={"tab2-".concat(node.id)}
                          role="tabpanel"
                          aria-labelledby="profile-tab"
                        >
                          <span
                            className="small d-block mb-2"
                            style={{
                              whiteSpace: "pre-wrap",
                              overflowY: "auto",
                            }}
                          >
                            {layers[node.id]?.abstract}
                          </span>
                        </div>
                        <div
                          className={"tab-pane fade "}
                          id={"tab3-".concat(node.id)}
                          role="tabpanel"
                          aria-labelledby="profile-tab"
                        >
                          <button
                            className="btn btn-sm btn-link border small m-1 d-inline-block"
                            type="button"
                            aria-expanded="false"
                            data-bs-toggle="collapse"
                            data-bs-target={"#sidebar"}
                            onClick={(e) => {
                              let cqlFilter = cqlFilters.cqlFilters;

                              store.dispatch({
                                type: "cqlFilter/update",
                                payload: {
                                  id: layers[node.id].id,
                                  groups: cqlFilter[node.id]
                                    ? cqlFilter[node.id]?.groups
                                      ? cqlFilter[node.id].groups
                                      : []
                                    : [],
                                },
                              });

                              store.dispatch({
                                type: "app/leftPanelActiveTab",
                                payload: "cqlFilter",
                              });
                            }}
                          >
                            <i className="fas fa-filter me-2"></i>
                            {layers[node.id].cqlFilter
                              ? "Edit CQL Filter"
                              : "Add CQL Filter"}
                          </button>
                          {layers[node.id].cqlFilter ? (
                            <button
                              className="btn btn-sm btn-link border small m-1 d-inline-block"
                              type="button"
                              aria-expanded="false"
                              data-bs-toggle="collapse"
                              data-bs-target={"#sidebar"}
                              onClick={(e) => {
                                removeLayerCQL(layers[node.id]);
                                store.dispatch({
                                  type: "cqlFilter/layer/delete",
                                  payload: {
                                    id: layers[node.id].id,
                                  },
                                });
                              }}
                            >
                              <i className="fas fa-filter me-2"></i>
                              {trans("Remove CQL Filter")}
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          className={"tab-pane fade "}
                          id={"tab4-".concat(node.id)}
                          role="tabpanel"
                          aria-labelledby="legend-tab"
                        >
                          <div class="form-check">
                            <input
                              class="me-2"
                              type="checkbox"
                              checked={layers[node.id].searchable}
                              id="searchable-check"
                              onChange={(e) => {
                                store.dispatch({
                                  type: "layer/update",
                                  payload: {
                                    id: node.layer.id,
                                    property: "searchable",
                                    value: e.target.checked,
                                  },
                                });
                              }}
                            />
                            <label
                              class="form-check-label"
                              for="searchable-check"
                            >
                              {trans("Searchable")}
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="me-2"
                              type="checkbox"
                              checked={layers[node.id].queryable}
                              id="queryable-check"
                              onChange={(e) => {
                                store.dispatch({
                                  type: "layer/update",
                                  payload: {
                                    id: node.layer.id,
                                    property: "queryable",
                                    value: e.target.checked,
                                  },
                                });
                              }}
                            />
                            <label
                              class="form-check-label"
                              for="queryable-check"
                            >
                              {trans("Queryable")}
                            </label>
                          </div>
                          {layers[node.id]?.source.type !== "GEOJSON" &&
                          layers[node.id]?.source.type !== "WFS" ? (
                            <div class="form-check">
                              <input
                                class="me-2"
                                type="checkbox"
                                checked={layers[node.id].singleTile}
                                id="single-tile-check"
                                onChange={(e) => {
                                  store.dispatch({
                                    type: "layer/update",
                                    payload: {
                                      id: node.layer.id,
                                      property: "singleTile",
                                      value: e.target.checked,
                                    },
                                  });
                                }}
                              />
                              <label
                                class="form-check-label"
                                for="single-tile-check"
                              >
                                {trans("Single Tiled")}
                              </label>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
              return null;
            },
            remove: () => {
              if (node.type === "layer") {
                window["primaryModal"].setState({
                  show: true,
                  size: "default",
                  title: trans("Delete confirmation"),
                  body: (
                    <div className="p-2">
                      {trans("Are you sure you want to remove layer")}{" "}
                      <strong>"{layers[node.id].title}"</strong>
                    </div>
                  ),
                  footer: [
                    <button
                      className="btn btn-sm btn-link"
                      onClick={(e) => {
                        window["primaryModal"].setState({
                          show: false,
                        });
                      }}
                    >
                      {trans("Cancel")}
                    </button>,
                    <button
                      className="btn btn-sm btn-danger text-white"
                      onClick={(e) => {
                        store.dispatch({
                          type: "layer/deleteById",
                          payload: node.id,
                        });
                        window["primaryModal"].setState({
                          show: false,
                        });
                      }}
                    >
                      {trans("Delete")}
                    </button>,
                  ],
                });
              } else {
                window["primaryModal"].setState({
                  show: true,
                  size: "default",
                  title: trans("Delete confirmation"),
                  body: (
                    <div className="p-2">
                      {trans("Are you sure you want to group")}{" "}
                      <strong>"{node.title}"</strong>{" "}
                      {trans("and all layers under it?")}
                    </div>
                  ),
                  footer: [
                    <button
                      className="btn btn-sm btn-link"
                      onClick={(e) => {
                        window["primaryModal"].setState({
                          show: false,
                        });
                      }}
                    >
                      {trans("Cancel")}
                    </button>,
                    <button
                      className="btn btn-sm btn-danger text-white"
                      onClick={(e) => {
                        // store.dispatch({
                        //   type: "layerTree/group/delete",
                        //   payload: treeIndex,
                        // });

                        let layersToBeRemoved = [];
                        let groupsToBeRemoved = [];

                        walk({
                          treeData: layerTree,
                          getNodeKey: ({ treeIndex }) => treeIndex,
                          ignoreCollapsed: true,
                          callback: (rowInfoIter) => {
                            if (rowInfoIter.path.indexOf(treeIndex) >= 0) {
                              if (rowInfoIter.node.type === "layer") {
                                layersToBeRemoved.push(rowInfoIter.node.id);
                              } else {
                                groupsToBeRemoved.push(rowInfoIter.node.id);
                              }
                            }
                          },
                        });

                        layersToBeRemoved.forEach((el) => {
                          store.dispatch({
                            type: "layer/deleteById",
                            payload: el,
                          });
                        });

                        groupsToBeRemoved.forEach((el) => {
                          store.dispatch({
                            type: "layerTree/group/delete",
                            payload: el,
                          });
                        });

                        window["primaryModal"].setState({
                          show: false,
                        });
                      }}
                    >
                      {trans("Delete")}
                    </button>,
                  ],
                });
              }
            },
            title: () => {
              let loaded = false;

              if (node.type === "layer") {
                if (layers[node.layer.id]) {
                  if (layers[node.layer.id].loaded) {
                    loaded = true;
                  }
                }
              } else {
                loaded = true;
              }

              return (
                <div
                  className="d-flex mt-1 "
                  style={{
                    alignItems: "flex-start",
                  }}
                >
                  <Checkbox
                    checked={isChecked(node)}
                    className="d-flex mt-1 me-1 ms-2"
                    disabled={!loaded}
                    indeterminate={isIntermidiate(node)}
                    onChange={(e) => {
                      let updatedNode = cloneDeep(node);
                      updatedNode.checked = e.currentTarget.checked;

                      if (node.type === "layer" && loaded) {
                        setLayerVisibility(node.layer, e.currentTarget.checked);
                        store.dispatch({
                          type: "layer/update",
                          payload: cloneDeep({
                            id: node.layer.id,
                            property: "visibility",
                            value: e.currentTarget.checked,
                          }),
                        });
                      }

                      function reccursive(data) {
                        return data?.children?.map((el) => {
                          el.checked = e.currentTarget.checked;

                          if (el.type === "layer") {
                            if (getLayerById(el.layer.id)) {
                              setLayerVisibility(
                                el.layer,
                                e.currentTarget.checked
                              );
                              let id = el.layer.id;
                              store.dispatch({
                                type: "layer/update",
                                payload: {
                                  id: id,
                                  property: "visibility",
                                  value: e.currentTarget.checked,
                                },
                              });
                            }
                          }

                          reccursive(el);

                          return el;
                        });
                      }

                      updatedNode.children = reccursive(updatedNode);

                      const newTree = changeNodeAtPath({
                        treeData: layerTree,
                        path,
                        getNodeKey: ({ treeIndex }) => treeIndex,
                        newNode: updatedNode,
                      });

                      store.dispatch({
                        type: "layerTree/state/update",
                        payload: newTree,
                      });
                    }}
                  />

                  {node.type === "layer" ? (
                    <span
                      className={"small d-block ".concat(
                        !loaded ? "text-muted" : ""
                      )}
                      role="button"
                      disable
                      onClick={() => {}}
                    >
                      {!loaded ? (
                        <i
                          className="fas fa-exclamation-triangle me-1"
                          title={trans("Layer not loaded yet")}
                        ></i>
                      ) : (
                        ""
                      )}
                      {layers[node.id] ? (
                        layers[node.id].cqlFilter ? (
                          <i
                            className="fas fa-filter me-1"
                            title={trans("CQL Filter enabled")}
                          ></i>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target={"#collapse-".concat(treeIndex)}
                      >
                        {layers[node.id] ? layers[node.id].title : node.title}
                      </span>
                    </span>
                  ) : (
                    <span
                      className="small d-block"
                      role="button"
                      disable
                      onClick={() => {}}
                    >
                      <span
                        data-bs-toggle="collapse"
                        data-bs-target={"#collapse-".concat(treeIndex)}
                      >
                        {layers[node.id] ? layers[node.id].title : node.title}
                      </span>
                    </span>
                  )}
                </div>
              );
            },
          })}
        ></SortableTree>
      </PerfectScrollbar>
    </div>
  );
}

export default LayerTree;
